export const PERFIL = {
  FORNECEDOR: 12,
  GESTOR_RESERVA_COMPRAS: 13,
} as const

// Padrão do multiplicador de venda em Compras/Reserva — também o teto: só é editável
// quando o divisor do item da proposta é menor que esse valor (ver regra em
// ComprasOrdemServicoService.cs, POST /ComprasOrdemServico/edit/compras-os).
export const MULTIPLICADOR_VENDA_PADRAO = 0.55
